/** The two sides of a Lancer fight: the **player** side and the **NPC/GM** side. */
export type Side = "pc" | "npc";

/** Whether a value is a valid {@link Side} — the runtime narrowing behind `set_controller`'s enum. */
export function isSide(v: unknown): v is Side {
  return v === "pc" || v === "npc";
}
